import {writable} from 'svelte/store';

/**
 * Extends a writable svelte store by a reset method
 */
export function resettable<T>(initialState: T) {
  const writableStore = writable<T>(initialState);

  return {
    ...writableStore,
    reset: () => {
      let currentState;
      writableStore.subscribe(value => {
        currentState = value;
      });

      // Reset state if the current state is not the initial one
      if (currentState !== initialState) {
        writableStore.set(initialState);
      }
    }
  };
}
